import { Component } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { UserCreationService } from 'src/app/service/user-creation.service';
import { ToastService } from 'src/app/shared/toast-service.service';
@Component({
  selector: 'app-profile',
  templateUrl: './profile.component.html',
  styleUrls: ['./profile.component.scss']
})
export class ProfileComponent {
  logoUrl: string = sessionStorage.getItem('logoUrl')?.trim() || 'assets/images/nopictures.png';
  USER_NAME: string = sessionStorage.getItem('USER_NAME')?.trim() || '';
 ROLE: string =  sessionStorage.getItem('ROLE')?.trim() || '';
  billingType: string =  sessionStorage.getItem('billingType')?.trim() || '';        
  emailId: string =  sessionStorage.getItem('emailId')?.trim() || '';
password: string = JSON.parse(sessionStorage.getItem('password') || '""');
  profileform: FormGroup;
  firstName: any;
  isVisible = false;

  constructor(private fb: FormBuilder, public User:UserCreationService, public toastService: ToastService) {
    // ✅ Initialize the form first

    // ✅ Then subscribe to valueChanges

  //  this.profileform = this.fb.group({
  //   userName: [this.USER_NAME],
  //   role:[this.ROLE],
  //   email:[this.emailId],
  //   billingtype:[this.billingType],
  //   oldPassword: [this.password],
  //   newPassword:['']
  // });

  this.profileform = this.fb.group({
  userName: [this.USER_NAME],
  role:[this.ROLE],
  email:[this.emailId],
  billingtype:[this.billingType],
  oldPassword: [this.password],
  newPassword:[''],
  confirmPassword:['']
});

  }
   showModal(): void {
    this.isVisible = true;
  }

  showOldPassword = false;
  showNewPassword = false;
  showConfirmPassword = false;
  showPasswordRules = false;

  get passwordValue(): string {
  return this.profileform.get('newPassword')?.value || '';
}

get hasMinLength(): boolean {
  return this.passwordValue.length >= 8;
}

get hasUpperCase(): boolean {
  return /[A-Z]/.test(this.passwordValue);
}

get hasLowerCase(): boolean {
  return /[a-z]/.test(this.passwordValue);
}

get hasNumber(): boolean {
  return /\d/.test(this.passwordValue);
}

get hasSpecialChar(): boolean {
  return /[!@#$%^&*(),.?":{}|<>]/.test(this.passwordValue);
}

get passwordsMatch(): boolean {
  return (
    this.profileform.get('confirmPassword')?.value &&
    this.profileform.get('newPassword')?.value ===
      this.profileform.get('confirmPassword')?.value
  );
}


handleOk(): void {

  if (
    !this.hasMinLength ||
    !this.hasUpperCase ||
    !this.hasLowerCase ||
    !this.hasNumber ||
    !this.hasSpecialChar
  ) {
    this.toastService.publishNotification(
      'Error',
      'Password does not meet the required criteria.',
      'error'
    );
    return;
  }

  if (!this.passwordsMatch) {
    this.toastService.publishNotification(
      'Error',
      'Passwords do not match.',
      'error'
    );
    return;
  }

  const payload = {
    loggedInUserName: sessionStorage.getItem('USER_NAME') || '',
    oldPassword: JSON.parse(sessionStorage.getItem('password') || '""'),
    newPassword: this.profileform.get('newPassword')?.value
  };

  this.User.updatepassword(payload).subscribe({
    next: (response: any) => {
      console.log('Password updated successfully', response);

      this.toastService.publishNotification(
        'Success',
        response.message,
        'success'
      );

      // Update stored password
      sessionStorage.setItem(
        'password',
        JSON.stringify(payload.newPassword)
      );

      // Reset password fields
      this.profileform.patchValue({
        oldPassword: payload.newPassword,
        newPassword: '',
        confirmPassword: ''
      });

      // Reset validation state
      this.showPasswordRules = false;
      this.showOldPassword = false;
      this.showNewPassword = false;
      this.showConfirmPassword = false;

      this.isVisible = false;
    },
    error: (error: any) => {
      console.error('Failed to update password', error);

      this.toastService.publishNotification(
        'Error',
        error?.message || 'Failed to update password.',
        'error'
      );
    }
  });
}


  handleCancel(): void {
    console.log('Button cancel clicked!');
    this.isVisible = false;
  }
}
